import AgentStatsV from './AgentStats.v';
import { withRouter } from 'core/withRouter';
import React, { useEffect, useState } from 'react';
import receptionService from 'services/reception.service';
import PageUtil from 'utils/Page.util';
import moment from 'moment';

class Params {
    error: string | null = null;
    isLoaded: boolean = false;

    selectedYear: string = moment().format('YYYY');
    selectedMonth: string = '';

    agentStatsData: Array<{
        agent: string;
        tripCount: number;
        holidayCount: number;
        floorCleanCount: number;
        tripFeeAmount: number;
        profit: number;
        freeCount: number;
    }> = [];
}

function AgentStats(props: any) {
    const [params, setParams] = useState(new Params());

    useEffect(() => {
        loadAgentStats();
    }, [params.selectedYear, params.selectedMonth]);

    /**
     * 출장자별 통계 데이터 로드
     */
    async function loadAgentStats() {
        try {
            setParams(prev => ({ ...prev, isLoaded: false }));

            const data = await receptionService.getAgentStats(
                parseInt(params.selectedYear),
                params.selectedMonth ? parseInt(params.selectedMonth) : 0
            );

            setParams(prev => ({
                ...prev,
                isLoaded: true,
                error: null,
                agentStatsData: data
            }));
        } catch (error) {
            setParams(prev => ({
                ...prev,
                isLoaded: true,
                error: error as any
            }));
            PageUtil.handleApiError(error);
        }
    }

    /**
     * 필드 변경 핸들러
     */
    function handleChange(e: any, field: string, value: any) {
        setParams(prev => ({
            ...prev,
            [field]: value
        }));
    }

    /**
     * 데이터 새로고침
     */
    function refreshData() {
        loadAgentStats();
    }

    const args = {
        params,
        setParams,
        handleChange,
        loadAgentStats,
        refreshData
    };

    return <AgentStatsV {...args} />;
}

export default withRouter(AgentStats);